import type { Locale } from 'next-intl';

export function coalesce<T>(...values: (null | T | undefined)[]): T {
	for (const v of values) {
		if (v !== null && v !== undefined) {
			return v;
		}
	}

	return values[values.length - 1] as T;
}

export function normalizeSelectValue(value: unknown): string[] {
	if (Array.isArray(value)) {
		return value.map(v => (typeof v === 'string' ? v : String(v ?? '')));
	}

	if (value == null || value === '') {
		return [];
	}

	if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
		return [ String(value) ];
	}

	return [];
}

export const calculateAge = (dob: Date | null) =>
	(dob ? Math.floor((Date.now() - dob.getTime()) / (1000 * 60 * 60 * 24 * 365.25)) : null);

type Entity = {
	chain:     { localized: Record<string, string> }[]
	localized: Record<string, string>
};

export const pickDeepestName = (
	entity: Entity | undefined,
	locale: Locale,
) => {
	if (!entity) return '';

	const chain = entity.chain ?? [];

	if (chain.length > 0) {
		return (chain[chain.length - 1]?.localized?.[locale]) ?? '';
	}

	return entity.localized?.[locale] ?? '';
};
